package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class MedicineName(private val literal: String) : IEnumType {
	麻黄("麻黄"),
	桂枝("桂枝"),
	紫苏("紫苏"),
	生姜("生姜"),
	荆芥("荆芥"),
	防风("防风"),
	羌活("羌活"),
	白芷("白芷"),
	细辛("细辛"),
	香薷("香薷"),
	藁本("藁本"),
	辛夷("辛夷"),
	葱白("葱白"),
	苍耳子("苍耳子"),
	薄荷("薄荷"),
	牛蒡子("牛蒡子"),
	桑叶("桑叶"),
	菊花("菊花"),
	蝉蜕("蝉蜕"),
	蔓荆子("蔓荆子"),
	淡豆豉("淡豆豉"),
	浮萍("浮萍"),
	柴胡("柴胡"),
	升麻("升麻"),
	葛根("葛根"),
	石膏("石膏"),
	知母("知母"),
	栀子("栀子"),
	芦根("芦根"),
	天花粉("天花粉"),
	淡竹叶("淡竹叶"),
	决明子("决明子"),
	夏枯草("夏枯草"),
	黄芩("黄芩"),
	黄连("黄连"),
	黄柏("黄柏"),
	龙胆("龙胆"),
	苦参("苦参"),
	白鲜皮("白鲜皮"),
	紫草("紫草"),
	青黛("青黛"),
	射干("射干"),
	山豆根("山豆根"),
	马勃("马勃"),
	半枝莲("半枝莲"),
	地锦草("地锦草"),
	金荞麦("金荞麦"),
	绿豆("绿豆"),
	金银花("金银花"),
	连翘("连翘"),
	板蓝根("板蓝根"),
	大青叶("大青叶"),
	蒲公英("蒲公英"),
	鱼腥草("鱼腥草"),
	大血藤("大血藤"),
	白头翁("白头翁"),
	马齿苋("马齿苋"),
	紫花地丁("紫花地丁"),
	白花蛇舌草("白花蛇舌草"),
	野菊花("野菊花"),
	漏芦("漏芦"),
	生地黄("生地黄"),
	玄参("玄参"),
	牡丹皮("牡丹皮"),
	赤芍("赤芍"),
	水牛角("水牛角"),
	白薇("白薇"),
	青蒿("青蒿"),
	地骨皮("地骨皮"),
	大黄("大黄"),
	芒硝("芒硝"),
	番泻叶("番泻叶"),
	火麻仁("火麻仁"),
	郁李仁("郁李仁"),
	甘遂("甘遂"),
	牵牛子("牵牛子"),
	巴豆("巴豆"),
	制大黄("制大黄"),
	芫花("芫花"),
	大戟("大戟"),
	商陆("商陆"),
	独活("独活"),
	威灵仙("威灵仙"),
	木瓜("木瓜"),
	防己("防己"),
	秦艽("秦艽"),
	桑寄生("桑寄生"),
	五加皮("五加皮"),
	槲寄生("槲寄生"),
	路路通("路路通"),
	川乌("川乌"),
	蕲蛇("蕲蛇"),
	乌梢蛇("乌梢蛇"),
	雷公藤("雷公藤"),
	丝瓜络("丝瓜络"),
	伸筋草("伸筋草"),
	海风藤("海风藤"),
	广藿香("广藿香"),
	藿香("藿香"),
	厚朴("厚朴"),
	苍术("苍术"),
	砂仁("砂仁"),
	草豆蔻("草豆蔻"),
	草果("草果"),
	佩兰("佩兰"),
	茯苓("茯苓"),
	薏苡仁("薏苡仁"),
	猪苓("猪苓"),
	泽泻("泽泻"),
	车前子("车前子"),
	滑石("滑石"),
	茵陈("茵陈"),
	金钱草("金钱草"),
	虎杖("虎杖"),
	萹蓄("萹蓄"),
	瞿麦("瞿麦"),
	石韦("石韦"),
	海金沙("海金沙"),
	萆薢("萆薢"),
	附子("附子"),
	干姜("干姜"),
	肉桂("肉桂"),
	吴茱萸("吴茱萸"),
	高良姜("高良姜"),
	花椒("花椒"),
	丁香("丁香"),
	小茴香("小茴香"),
	荜茇("荜茇"),
	陈皮("陈皮"),
	枳实("枳实"),
	木香("木香"),
	香附("香附"),
	薤白("薤白"),
	佛手("佛手"),
	青皮("青皮"),
	橘核("橘核"),
	沉香("沉香"),
	枳壳("枳壳"),
	乌药("乌药"),
	川楝子("川楝子"),
	大腹皮("大腹皮"),
	檀香("檀香"),
	甘松("甘松"),
	九香虫("九香虫"),
	香橼("香橼"),
	山楂("山楂"),
	麦芽("麦芽"),
	神曲("神曲"),
	槟榔("槟榔"),
	莱菔子("莱菔子"),
	鸡内金("鸡内金"),
	谷芽("谷芽"),
	使君子("使君子"),
	苦楝皮("苦楝皮"),
	白及("白及"),
	仙鹤草("仙鹤草"),
	小蓟("小蓟"),
	三七("三七"),
	槐花("槐花"),
	白茅根("白茅根"),
	蒲黄("蒲黄"),
	艾叶("艾叶"),
	大蓟("大蓟"),
	侧柏叶("侧柏叶"),
	藕节("藕节"),
	紫珠叶("紫珠叶"),
	地榆("地榆"),
	血余炭("血余炭"),
	花蕊石("花蕊石"),
	棕榈炭("棕榈炭"),
	川芎("川芎"),
	延胡索("延胡索"),
	郁金("郁金"),
	丹参("丹参"),
	牛膝("牛膝"),
	红花("红花"),
	桃仁("桃仁"),
	益母草("益母草"),
	莪术("莪术"),
	姜黄("姜黄"),
	乳香("乳香"),
	没药("没药"),
	三棱("三棱"),
	五灵脂("五灵脂"),
	泽兰("泽兰"),
	鸡血藤("鸡血藤"),
	穿山甲("穿山甲"),
	水蛭("水蛭"),
	土鳖虫("土鳖虫"),
	王不留行("王不留行"),
	血竭("血竭"),
	刘寄奴("刘寄奴"),
	苏木("苏木"),
	降香("降香"),
	半夏("半夏"),
	天南星("天南星"),
	旋覆花("旋覆花"),
	桔梗("桔梗"),
	川贝母("川贝母"),
	浙贝母("浙贝母"),
	瓜蒌("瓜蒌"),
	竹茹("竹茹"),
	竹沥("竹沥"),
	白前("白前"),
	前胡("前胡"),
	昆布("昆布"),
	海藻("海藻"),
	天竺黄("天竺黄"),
	白芥子("白芥子"),
	皂荚("皂荚"),
	黄芩子("黄芩子"),
	瓦楞子("瓦楞子"),
	苦杏仁("苦杏仁"),
	紫苏子("紫苏子"),
	苏子("苏子"),
	枇杷叶("枇杷叶"),
	百部("百部"),
	紫菀("紫菀"),
	款冬花("款冬花"),
	桑白皮("桑白皮"),
	葶苈子("葶苈子"),
	白果("白果"),
	马兜铃("马兜铃"),
	矮地茶("矮地茶"),
	酸枣仁("酸枣仁"),
	柏子仁("柏子仁"),
	首乌藤("首乌藤"),
	远志("远志"),
	朱砂("朱砂"),
	龙骨("龙骨"),
	合欢皮("合欢皮"),
	灵芝("灵芝"),
	磁石("磁石"),
	琥珀("琥珀"),
	石决明("石决明"),
	珍珠母("珍珠母"),
	牡蛎("牡蛎"),
	代赭石("代赭石"),
	蒺藜("蒺藜"),
	罗布麻叶("罗布麻叶"),
	羚羊角("羚羊角"),
	牛黄("牛黄"),
	钩藤("钩藤"),
	天麻("天麻"),
	僵蚕("僵蚕"),
	地龙("地龙"),
	全蝎("全蝎"),
	麝香("麝香"),
	冰片("冰片"),
	苏合香("苏合香"),
	石昌蒲("石昌蒲"),
	安息香("安息香"),
	人参("人参"),
	西洋参("西洋参"),
	党参("党参"),
	黄芪("黄芪"),
	白术("白术"),
	甘草("甘草"),
	大枣("大枣"),
	太子参("太子参"),
	白扁豆("白扁豆"),
	扁豆衣("扁豆衣"),
	山药("山药"),
	当归("当归"),
	熟地黄("熟地黄"),
	阿胶("阿胶"),
	何首乌("何首乌"),
	白芍("白芍"),
	北沙参("北沙参"),
	南沙参("南沙参"),
	麦冬("麦冬"),
	枸杞子("枸杞子"),
	女贞子("女贞子"),
	龟甲("龟甲"),
	鳖甲("鳖甲"),
	黄精("黄精"),
	天冬("天冬"),
	玉竹("玉竹"),
	百合("百合"),
	沙参("沙参"),
	龙眼肉("龙眼肉"),
	桑椹("桑椹"),
	墨旱莲("墨旱莲"),
	石斛("石斛"),
	鹿茸("鹿茸"),
	鹿角霜("鹿角霜"),
	淫羊藿("淫羊藿"),
	巴戟天("巴戟天"),
	杜仲("杜仲"),
	续断("续断"),
	冬虫夏草("冬虫夏草"),
	菟丝子("菟丝子"),
	补骨脂("补骨脂"),
	益智("益智"),
	紫河车("紫河车"),
	肉苁蓉("肉苁蓉"),
	锁阳("锁阳"),
	蛤蚧("蛤蚧"),
	核桃仁("核桃仁"),
	仙茅("仙茅"),
	五味子("五味子"),
	山茱萸("山茱萸"),
	桑螵蛸("桑螵蛸"),
	乌梅("乌梅"),
	肉豆蔻("肉豆蔻"),
	海螵蛸("海螵蛸"),
	乌贼骨("乌贼骨"),
	浮小麦("浮小麦"),
	赤石脂("赤石脂"),
	五倍子("五倍子"),
	莲子("莲子"),
	芡实("芡实"),
	荷叶("荷叶"),
	莲心("莲心"),
	诃子("诃子"),
	金樱子("金樱子"),
	覆盆子("覆盆子"),
	麻黄根("麻黄根"),
	椿皮("椿皮"),
	石榴皮("石榴皮"),
	常山("常山"),
	胆矾("胆矾"),
	硫黄("硫黄"),
	升药("升药"),
	硼砂("硼砂"),
	炉甘石("炉甘石"),
	雄黄("雄黄"),
	白矾("白矾"),
	白附子("白附子"),
	车前草("车前草"),
	灯心草("灯心草"),
	青礞石("青礞石"),
	茜草("茜草"),
	徐长卿("徐长卿"),
	紫苏叶("紫苏叶"),
	焦三仙("焦三仙"),
	蛇床子("蛇床子"),
	地肤子("地肤子"),
	银柴胡("银柴胡"),
	赤小豆("赤小豆"),
	忍冬藤("忍冬藤"),
	狗脊("狗脊"),
	桑枝("桑枝"),
	冬葵子("冬葵子"),
	老鹳草("老鹳草"),
	土茯苓("土茯苓"),
	冬瓜子("冬瓜子"),
	蝉衣("蝉衣"),
	红藤("红藤"),
	败酱草("败酱草"),
	绿萼梅("绿萼梅"),
	充蔚子("充蔚子"),
	骨碎补("骨碎补"),
	红曲("红曲"),
	重楼("重楼"),
	月季花("月季花"),
	苎麻根("苎麻根"),
	紫贝齿("紫贝齿"),
	沙苑子("沙苑子"),
	橘叶("橘叶"),
	石见穿("石见穿"),
	穿破石("穿破石");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "medicine_name"}
	override fun getLiteral(): String {return literal}
}
